import * as React from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";

import {
	setDate,
	openAddReservationDialog,
	activateTableLinkMode,
	activateTableLinkDeletionMode
} from "../../actions/store/app-actions";

import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LayersIcon from "@material-ui/icons/Layers";
import HelpIcon from "@material-ui/icons/Help";
import LockIcon from "@material-ui/icons/Lock";
import LinkIcon from "@material-ui/icons/Link";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { formatDate } from "../../util/date-utility";
import {
	showAdditionalInfo,
	hideAdditionalInfo,
	toggleInfoBar,
	setActiveArea
} from "../../actions/store/overview-actions";
import { DatePicker, ConnectedDatePicker } from "../datepicker";
import { toggleLockForSelectedDay } from "../../actions/occupied-day-actions";
import { Area } from "../../api/areas";
import { ConnectedAreaSelect } from "./area-select";

export interface DateSelectProps {}

interface ConnectedDateSelectProps extends WithStyles<typeof styles> {
	selectedDate: Date;
	layout: "desktop" | "tablet" | "phone";
	setDate: (date: Date) => void;
}

type Props = DateSelectProps &
	ConnectedDateSelectProps &
	InjectedTranslateProps;

export class DateSelect extends React.Component<Props, {}> {
	private datepickerRef: DatePicker;

	private handleDateSelectClick = async () => {
		await this.datepickerRef.open();
	};

	private handleDatePickerChange = (date: Date) => {
		this.props.setDate(date);
	};

	private handleDatePickerRef = (ref: DatePicker) => {
		this.datepickerRef = ref;
	};

	public render() {
		const { classes, selectedDate, layout } = this.props;

		return (
			<React.Fragment>
				<Button
					className={classNames(
						classes.dropdownButton,
						classes.dateSelectButton
					)}
					variant={layout === "phone" ? "text" : "outlined"}
					color="inherit"
					onClick={this.handleDateSelectClick}
				>
					<EventNoteIcon className={classes.iconSmall} />
					<span className={classes.iconButtonLabel}>
						{formatDate(selectedDate)}
					</span>
				</Button>
				<div className={classes.hidden}>
					<ConnectedDatePicker
						value={selectedDate}
						onRef={this.handleDatePickerRef}
						onChange={this.handleDatePickerChange}
					/>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	selectedDate: state.date,
	layout: state.layout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setDate: (date: Date) => dispatch(setDate(date))
});

const styles = (theme: Theme) =>
	createStyles({
		iconSmall: {
			fontSize: 20
		},
		iconButtonLabel: {
			textTransform: "none",
			paddingLeft: 6,
			paddingRight: 6
		},
		dateSelectButton: {
			marginRight: 8
		},
		dropdownButton: {
			paddingLeft: 8,
			paddingRight: 8,
			borderColor: "rgba(255, 255, 255, 0.3)"
		},
		hidden: {
			position: "absolute",
			zIndex: -55,
			visibility: "hidden"
		}
	});

export const ConnectedDateSelect = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(DateSelect)
	)
);
